module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/6_e2ebd306155b3722de83aa70f6837acc.png";